module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray-6d03a8eec4f7ac6f8b9cfb157fa16941.png";